import axios, { AxiosInstance } from "axios";

export const apiInstance: AxiosInstance = axios.create({
  validateStatus: () => true,
});
